import { cloneDeep, first, isEqual } from "lodash";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../common_widgets/popup";
import MdaeDataGrid, { IMdaeDataGridProps } from "../common_widgets/data-grid";
import MdaeButton from "../common_widgets/button";
import {
  SET_USER_TASK_BULK_EDIT_DATA,
  SET_USER_TASK_FORM_DATA,
  TOGGLE_SELECT_EXTERNAL_USER_POPUP,
} from "../user-task-list/reducers/user-task-list-reducer";
import { toggleSelectExternalUserPopup } from "../user-task-list/add-user-task";
import "./index.scss";
import $ from "jquery";
import {
  FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
  SET_TASK_TEMPLATE_FORM_DATA,
  SET_TASK_TEMPLATE_FORM_DATA_SET_ACTIVE_USER_LIST,
} from "../../pages/task-template/reducers/task-template-reducer";
import { SET_TASK_FORM_DATA } from "../../pages/external-audit-setup/process-template/reducer/process-template-reducer";

const continueButtonTitle =
  "Select an external user above by clicking on their name in order to continue";

interface ISelectExternalUserProps {
  getAssignedUserList?: (
    auditGroupId: number,
    isFromAssignedToField: boolean
  ) => any[];
  auditGroupId?: number;
  isPopupOpenedFromTaskTemplate?: boolean;
  isPopupOpenedFromBulkEdit?: boolean;
  selectedRowsDataForBulkEdit?: any[];
  isPopupOpenedFromProcessTemplateTaskTrigger?: boolean;
  getAssignToList?: (selectedRowsDataForBulkEdit: any[]) => any[];
}

const SelectExternalUser: React.FC<ISelectExternalUserProps> = (props) => {
  const dispatch = useDispatch();
  const [
    selectExternalUserDataGridInstance,
    setSelectExternalUserDataGridInstance,
  ] = useState(null);
  const externalUserList = useSelector(
    (state: any) =>
      state.externalUsersReducer.externalUserListForExternalUserGroup,
    isEqual
  );
  const isSelectUserPopupOpenedFromCompletedBy = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectUserPopupOpenedFromCompletedBy,
    isEqual
  );
  const assignedToUserTypeList = useSelector(
    (state: any) => state.taskTemplateReducer.assignedToUserTypeList,
    isEqual
  );
  const taskFormData = useSelector(
    (state: any) => state.processTemplateReducer.taskFormData,
    isEqual
  );
  const activeUserList = useSelector(
    (state: any) => state.taskTemplateReducer.activeUserList,
    isEqual
  );
  const isSelectUserPopupOpenedFromCompletedByBulkEdit = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectUserPopupOpenedFromCompletedByBulkEdit,
    isEqual
  );
  const [currentSelectedRowData, setCurrentSelectedRowData] = useState(null);

  const onSelectExternalUserDataGridInitialized = (e) => {
    setSelectExternalUserDataGridInstance(e.component);
  };

  const onSelectExternalUserDataGridSelectionChanged = (e) => {
    setCurrentSelectedRowData(e);
  };

  const selectExternalUserDataGridOptions = useMemo(() => {
    return getSelectExternalUserDataGridOptions(
      externalUserList,
      onSelectExternalUserDataGridInitialized,
      onSelectExternalUserDataGridSelectionChanged
    );
  }, [externalUserList]);

  const getSelectExternalUserPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleSelectExternalUserPopup(dispatch, false);
        }}
      >
        Select External User
      </MdaePopupTitle>
    );
  };

  const selectExternalUserToExternalUserGroup = () => {
    var selectedRowsData = selectExternalUserDataGridInstance.getSelectedRowsData();
    if (selectedRowsData && selectedRowsData.length > 0) {
      const selectedExternalUser: any = cloneDeep(first(selectedRowsData));
      if (props.isPopupOpenedFromBulkEdit) {
        if (!isSelectUserPopupOpenedFromCompletedByBulkEdit) {
          dispatch({
            type: SET_USER_TASK_BULK_EDIT_DATA,
            data: {
              userTaskBulkEditData: {
                assignedToUserId: selectedExternalUser.externalUserId,
                isAssignedToExternalUser: true,
              },
            },
          });
        } else {
          dispatch({
            type: SET_USER_TASK_BULK_EDIT_DATA,
            data: {
              userTaskBulkEditData: {
                completedByUsedId: selectedExternalUser.externalUserId,
                isCompletedByExternalUser: true,
              },
            },
          });
        }
        if (props.selectedRowsDataForBulkEdit)
          props.getAssignToList(props.selectedRowsDataForBulkEdit);
      } else if (props.isPopupOpenedFromProcessTemplateTaskTrigger) {
        dispatch({
          type: SET_TASK_FORM_DATA,
          data: {
            taskFormData: {
              ...taskFormData,
              assignedToUserId: selectedExternalUser.externalUserId,
              isAssignedToExternalUser: true,
            },
          },
        });
      } else if (!props.isPopupOpenedFromTaskTemplate) {
        let isFromAssignedToField = false;
        if (!isSelectUserPopupOpenedFromCompletedBy) {
          isFromAssignedToField = true;
          dispatch({
            type: SET_USER_TASK_FORM_DATA,
            data: {
              userTaskFormData: {
                assignedToUserId: selectedExternalUser.externalUserId,
                isAssignedToExternalUser: true,
              },
            },
          });
        } else {
          isFromAssignedToField = false;
          dispatch({
            type: SET_USER_TASK_FORM_DATA,
            data: {
              userTaskFormData: {
                completedByUsedId: selectedExternalUser.externalUserId,
                isCompletedByExternalUser: true,
              },
            },
          });
        }
        if (props.auditGroupId && props.auditGroupId > 0)
          props.getAssignedUserList(props.auditGroupId, isFromAssignedToField);
      } else {
        if (assignedToUserTypeList && assignedToUserTypeList.length > 0) {
          let originalAssignedToUserTypeList = assignedToUserTypeList.filter(
            (x) => !x.externalUserId
          );
          let externalUser = externalUserList?.find(
            (x) => x.externalUserId === selectedExternalUser.externalUserId
          );
          if (externalUser?.externalUserId > 0) {
            externalUser.displayName =
              externalUser.externalUserName + ` (External User)`;
            externalUser.value = externalUser.externalUserId;
          }
          if (externalUser) originalAssignedToUserTypeList.push(externalUser);
          dispatch({
            type: FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
            assignedToUserTypeList: originalAssignedToUserTypeList,
          });
          dispatch({
            type: SET_TASK_TEMPLATE_FORM_DATA,
            data: {
              taskTemplateFormData: {
                assignedToUserTypeValue: selectedExternalUser.externalUserId,
                isTaskTemplateAssignedToExternalUser: true,
                assignedToUserId: selectedExternalUser.externalUserId,
              },
            },
          });
        }
      }
      toggleSelectExternalUserPopup(dispatch, false);
    }
  };
  const isSelectExternalUserPopupVisible = useSelector(
    (state) => state["userTaskListReducer"].isSelectExternalUserPopupVisible
  );
  return (
    <>
      <MdaePopup
        deferRendering={false}
        height={610}
        maxWidth={1000}
        id={"pnlSelectExternalUserPopup"}
        mdaeTitleRender={getSelectExternalUserPopupTitle}
        visible={isSelectExternalUserPopupVisible}
        mdaeContentRender={() => {
          return (
            <div className={"select-external-user-container"}>
              <div className={"select-external-user-list-container col-xs-12"}>
                <MdaeDataGrid
                  {...selectExternalUserDataGridOptions}
                ></MdaeDataGrid>
              </div>
            </div>
          );
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"btnCancelSelectExternalUser"}
                  role={"secondary"}
                  onClick={() => {
                    toggleSelectExternalUserPopup(dispatch, false);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <>
                  <div
                    style={{ marginRight: "10px" }}
                    title={currentSelectedRowData ? "" : continueButtonTitle}
                  >
                    <MdaeButton
                      id={"btnContinueSelectExternalUser"}
                      onClick={() => {
                        selectExternalUserToExternalUserGroup();
                      }}
                      role={"primary"}
                      disabled={!currentSelectedRowData}
                    >
                      Continue
                    </MdaeButton>
                  </div>
                </>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
    </>
  );
};

const getSelectExternalUserDataGridOptions = (
  externalUserList,
  onSelectExternalUserDataGridInitialized,
  onSelectExternalUserDataGridSelectionChanged
) => {
  const externalUserListDataGridOptions: IMdaeDataGridProps = {
    id: "grdSelectExternalUserList",
    mdaeColumnChooser: { isMdaeColumnChooserVisible: false },
    headerFilter: {
      visible: true,
    },
    allowColumnResizing: true,
    allowColumnReordering: true,
    filterRow: {
      visible: true,
    },
    keyExpr: "externalUserId",
    onInitialized: onSelectExternalUserDataGridInitialized,
    selection: { mode: "single" },
    pageSize: 10,
    height: "450px",
    onSelectionChanged: onSelectExternalUserDataGridSelectionChanged,
    onContentReady: () => {
      $(
        ".dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused).dx-row-lines > td, .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover.dx-row-lines > td"
      ).addClass("application-section-primary-background-color");
    },
    mdaeColumns: [
      {
        caption: "Name",
        dataField: "externalUserName",
      },
      {
        caption: "Email Address",
        dataField: "email",
      },
      {
        caption: "User Group",
        dataField: "externalUserGroupName",
      },
    ],
    dataSource: externalUserList,
  };
  return externalUserListDataGridOptions;
};

export default SelectExternalUser;
